import $ from 'jquery';

$(document).ready(function() {
    $('.js-sl-text').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
           }
        }
        ]
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/text-page/text-sl.js